/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type galleri_QueryVariables = {};
export type galleri_QueryResponse = {
    readonly photos: ReadonlyArray<{
        readonly photo: string;
    }> | null;
};
export type galleri_Query = {
    readonly response: galleri_QueryResponse;
    readonly variables: galleri_QueryVariables;
};



/*
query galleri_Query {
  photos {
    photo
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photo",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "galleri_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Photo",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "galleri_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Photo",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c42afe4b4e6997ae5196888cc0ff7944",
    "id": null,
    "metadata": {},
    "name": "galleri_Query",
    "operationKind": "query",
    "text": "query galleri_Query {\n  photos {\n    photo\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '15ec158835e5c533c21b0aad576719b4';
export default node;
